import { useRoPanelParams } from "@/hooks/useRoPanelParams";
import { useCard } from "@/hooks/store/useCard";
import { useStore } from "@/stores/useStore";
import { useMoveToDialog } from "@/components/DashboardList/hooks/useMoveToDialog";
import { MoveToDialog } from "@/components/DashboardList/components/MoveToDialog";
import { RoDetailsEmptyState } from "@/components/Common/RoDetailsPanel/RoDetailsEmptyState";
import { RoCardPreview } from "@/components/Common/RoDetailsPanel/RoCardPreview";
import { RoDetailsSummary } from "@/components/Common/RoDetailsPanel/RoDetailsSummary";
import { RoTechnicianAndAdvisor } from "@/components/Common/RoDetailsPanel/RoTechnicianAndAdvisor";
import { RoWorkOrderDetails } from "@/components/Common/RoDetailsPanel/RoWorkOrderDetails";
import { RoNotesCard } from "@/components/Common/RoDetailsPanel/RoNotesCard";
import { RoAttachmentsCard } from "@/components/Common/RoDetailsPanel/RoAttachmentsCard";
import { Jobs } from "@/components/Cards/Jobs";
import { RoMetricsTasksShells } from "@/components/Common/RoDetailsPanel/RoMetricsTasksShells";
import { RoDetailsHeaderActions } from "@/components/Common/RoDetailsPanel/RoDetailsHeaderActions";
import { RO_SECTION_TITLE_CLASS } from "@/components/Common/RoDetailsPanel/roPanelStyles";
import { generateIntegrationLinkUrl } from "@/lib/cards";

export const RoDetailsTab = () => {
  const { selectedCardId } = useRoPanelParams();
  const { card } = useCard(selectedCardId ?? undefined);
  const { shop, employees, integration, tags } = useStore();
  const {
    isOpen: isMoveDialogOpen,
    selectedCard: moveDialogCard,
    openDialog: openMoveDialog,
    closeDialog: closeMoveDialog,
    handleMoveSuccess,
  } = useMoveToDialog();

  if (!card || !shop) {
    return <RoDetailsEmptyState />;
  }

  return (
    <div className="flex h-full w-full flex-col pt-1">
      <RoDetailsHeaderActions
        cardData={card}
        shop={shop}
        integrationLinkUrl={
          integration
            ? generateIntegrationLinkUrl(integration, shop, card.id)
            : undefined
        }
        onMoveToClick={openMoveDialog}
      />
      <div className="flex w-full flex-1 flex-col gap-4 overflow-auto p-4">
        <RoCardPreview cardData={card} shop={shop} />
        <RoDetailsSummary cardData={card} tags={tags} shopId={shop.id} />
        <RoTechnicianAndAdvisor cardData={card} employees={employees} />
        <RoWorkOrderDetails cardData={card} />
        <Jobs
          jobs={card.jobs}
          titleClassName={RO_SECTION_TITLE_CLASS}
          employees={employees}
          serviceWriterId={card.serviceWriterId}
        />
        <RoNotesCard cardData={card} shopId={shop.id} />
        <RoAttachmentsCard cardData={card} shopId={shop.id} />
        <RoMetricsTasksShells cardData={card} />
      </div>
      {moveDialogCard && (
        <MoveToDialog
          isOpen={isMoveDialogOpen}
          onClose={closeMoveDialog}
          card={moveDialogCard}
          onMoveSuccess={handleMoveSuccess}
        />
      )}
    </div>
  );
};
